import React, { useState, useEffect, useRef } from "react";
import {
  f7,
  Page,
  Link,
  Button,
  Input,
  ListItem,
  Icon,
  Popup,
  Block,
  List,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, FUTURE_DATE } from "../globals";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import "./DatePicker.css";
import { useCallback } from "react";
import debounce from "lodash.debounce";

const EditOrder = ({ f7route }) => {
  const { id } = f7route.params;
  const [menu_item_id, setRestMenu] = useState(0);
  const formRef = useRef(null);
  const [menuSize, setMenuSize] = useState([]);
  const [citydata, setCityData] = useState([]);
  const [menuAmount, setMenuAmount] = useState(0);
  const [noOfPer, setNoOfPer] = useState(0);
  const [stateId, setStateId] = useState(0);
  const [totalAmt, setTotalAmt] = useState(0);
  const [menuItem, setMenuItem] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    rest_id: localStorage.getItem("id"),
    order_status: 1,
  });
  const [traySize, setTraySize] = useState(0);
  const [custEmail, setCustEmail] = useState("");
  const [custDetail, setCustDetail] = useState([]);
  const [custfName, setCustfName] = useState("");
  const [custlName, setCustlName] = useState("");
  const [custContactNo, setCustContactNo] = useState("");
  const [custId, setCustId] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isSubscription, setIsSubscription] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [orderStatus, setOrderStatus] = useState([]);
  const [selectedMenuSizeId, setSelectedMenuSizeId] = useState(0);
  const [menuNote, setMenuNote] = useState("");
  const [editIndex, setEditIndex] = useState(0);
  const [selectedRadio, setSelectedRadio] = useState();
  const [addressInfo, setAddressInfo] = useState();
  const [addressSuggestions, setAddressSuggestions] = useState([]);

  // console.log("formData", formData);
  const handleRadioChange = async (value) => {
    setSelectedRadio(value);
    let deliver = value == "1" ? "Delivery" : "Pick up";

    const orderData = JSON.parse(localStorage.getItem("order_data")) || {};
    // Update the delivery_type
    orderData.delivery_type = deliver;
    localStorage.setItem("order_data", JSON.stringify(orderData));
    setFormData({ ...formData, delivery_type: deliver });
  };
  useEffect(() => {
    axios
      .get(API_BASE_URL + "checksubscription", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          rest_id: localStorage.getItem("id"),
        },
      })
      .then((response) => {
        setIsSubscription(response.data);
        console.log(response.data);
      })
      .catch((error) => console.log(error));

    axios
      .get(API_BASE_URL + "state", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => setCityData(response.data))
      .catch((error) => console.log(error));
  }, []);
  const fetchDeliverTypeData = async () => {
    if (selectedRadio === "2") {
      // Set address-related fields to undefined
      setFormData((prevFormData) => ({
        ...prevFormData,
        add_lin_1: undefined,
        add_lin_2: undefined,
        city: undefined,
        state: undefined,
        zip_code: undefined,
        event_note: undefined,
      }));
    } else {
      // Fetch the data for "Delivery" type
      // try {
      // const response = await axios.get(API_BASE_URL + "acceptrestorder", {
      //   headers: {
      //     Authorization: "Basic " + API_AUTH,
      //   },
      //   params: {
      //     rest_id: localStorage.getItem("id"),
      //     order_id: id,
      //     limits: 100,
      //   },
      // });
      // const data = response.data.data[0];
      // console.log("response.data", response.data);
      setFormData((prevFormData) => ({
        ...prevFormData,
        ...addressInfo,
        // add_lin_1: data.add_lin_1,
        // add_lin_2: data.add_lin_2,
        // city: data.city,
        // state: data.state,
        // zip_code: data.zip_code,
        // event_note: data.event_note, // Update formData with fetched data
      }));
      // } catch (error) {
      //   console.error("Error fetching delivery data:", error);
      // }
    }
  };

  useEffect(() => {
    fetchDeliverTypeData();
  }, [selectedRadio]);
  const menuSizeAmount = (amount, noOfPer, menu_size_id) => {
    setMenuAmount(amount);
    setNoOfPer(noOfPer);
    setSelectedMenuSizeId(menu_size_id);
    setTotalAmt(0);
    setTraySize(0);
  };
  useEffect(() => {
    if (custEmail) {
      axios
        .get(API_BASE_URL + "customers", {
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
          params: {
            search_mail: custEmail,
          },
        })
        .then((response) => {
          console.log(response.data);
          setCustDetail(response.data);
        })
        .catch((error) => {
          console.log("Customer does't exist ");
          setCustDetail([]);
        });
    } else {
      setCustDetail([]);
    }
  }, [custEmail]);
  const calculateSum = (tray_size) => {
    const decimalRegex = /^\d*\.?\d*$/;
    console.log(decimalRegex.test(tray_size) == true);
    if (decimalRegex.test(tray_size) == true) {
      var unitAmt = tray_size * menuAmount;
      setTotalAmt(unitAmt);
      setTraySize(tray_size);
    } else {
      setTraySize("");
    }
  };
  useEffect(() => {
    calculateSum(traySize);
  }, [traySize, menuAmount]);
  const handleAddToCart = (event) => {
    event.preventDefault();
    const menu_name = event.target.elements.menu_name.value;
    const menu_id = menu_item_id;
    const rest_id = localStorage.getItem("id");
    const tray_size_id = event.target.elements.try_size.value;
    const menu_size = event.target.elements.menu_size.value;
    const menu_size_text =
      event.target.elements.menu_size.options[
        event.target.elements.menu_size.selectedIndex
      ].text;
    const menu_amount = event.target.elements.menu_amount.value;
    const size = event.target.elements.noOfPer.value;
    const note = event.target.elements.menu_note.value;
    if (menu_size == "Select Menu Size") {
      f7.toast
        .create({
          text: "Please Select Menu Size ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }
    if (menu_amount <= 0) {
      f7.toast
        .create({
          text: "Please Add Amount ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }

    if (tray_size_id <= 0 || !tray_size_id) {
      f7.toast
        .create({
          text: "Please Add Tray Size  ...!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }
    if (totalAmt <= 0) {
      f7.toast
        .create({
          text: "Please Add Tray Size ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }
    const menu_data = {
      menu_name: menu_name,
      menu_id: menu_id,
      rest_id: rest_id,
      tray_size_id: tray_size_id,
      menu_amount: menu_amount,
      size: size,
      note: note,
      item_status: 2,
      total_amount: totalAmt,
      menu_size: menu_size,
      menu_size_name: menu_size_text,
    };
    setMenuItem([...menuItem, menu_data]);
    f7.popup.close(".demo-popup");
    setSearchTerm("");
    setTotalAmt(0);
    setMenuAmount(0);
    setNoOfPer(0);
    setTraySize(0);
    formRef.current.reset();
  };
  useEffect(() => {
    // Update the formData whenever menuItem changes
    setFormData({
      ...formData,
      rest_id: localStorage.getItem("id"),
      order_status: 1,
      items: menuItem,
      // grand_total : menuItem.reduce((acc, item) => acc + item.total_amount, 0),
      sub_total: menuItem.reduce((acc, item) => acc + item.total_amount, 0),
      cust_email: custEmail,
      cust_fname: custfName,
      cust_lname: custlName,
      cust_contact_no: custContactNo,
      cust_id: custId,
      event_date: selectedDate,
      order_id: id,
    });
    console.log(formData.items);
  }, [
    id,
    menuItem,
    custEmail,
    custlName,
    custfName,
    custId,
    custContactNo,
    selectedDate,
  ]);

  // Delete
  const handleDelete = (index) => {
    const updatedProduct = [...menuItem];
    updatedProduct.splice(index, 1);
    setMenuItem(updatedProduct);
  };

  useEffect(() => {
    axios
      .get(API_BASE_URL + "acceptrestorder", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          rest_id: localStorage.getItem("id"),
          order_id: id,
          limits: 100,
        },
      })
      .then((response) => {
        console.log(response.data.data[0]);
        const dataString = JSON.stringify(response.data.data[0]);
        localStorage.setItem("order_data", dataString);
        setFormData(response.data.data[0]);
        setAddressInfo({
          add_lin_1: response.data.data[0].add_lin_1,
          add_lin_2: response.data.data[0].add_lin_2,
          city: response.data.data[0].city,
          state: response.data.data[0].state,
          zip_code: response?.data?.data[0]?.zip_code
            ? String(response.data.data[0].zip_code).replace(/\s+$/, "")
            : "",
          event_note: response.data.data[0].event_note,
        });
        setSelectedRadio(
          response.data.data[0].delivery_type == "Delivery" ? "1" : "2"
        );
        console.log(moment(response.data.data[0].edit_event_date).toDate());
        setSelectedDate(moment(response.data.data[0].edit_event_date).toDate());
        setCustfName(response.data.data[0].cust_name);
        setCustlName(response.data.data[0].cust_lname);
        setCustEmail(response.data.data[0].cust_email);
        setCustContactNo(response.data.data[0].cust_phone);
        setMenuItem(response.data.data[0].order_item);
        setStateId(response.data.data[0].state);
        setLoading(false);
        setError(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          // Handle 404 error here
          setLoading(false);
          setError(true);
        } else {
          console.error(error);
          setLoading(false);
          setError(true);
        }
      });

    axios
      .get(API_BASE_URL + "orderstatus", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        setOrderStatus(response.data.data);
      })
      .catch((error) => console.log(error));
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddressChange = (event) => {
    const value = event.target.value;
    setFormData({
      ...formData,
      add_lin_1: value,
    });
    // setAddressSearchTerm(value);
    debouncedFetchAddresses(value);
  };

  const debouncedFetchAddresses = useCallback(
    debounce((value) => {
      if (value.length > 0) {
        axios
          .get(API_BASE_URL + `googleapiaddresssearch/?input=${value}`, {
            headers: {
              Authorization: "Basic " + API_AUTH,
            },
          })
          .then((response) => {
            // const formattedAddress = response?.data?.data?.map(
            //   (add) => add?.formatted_address
            // );

            setAddressSuggestions(response?.data?.data?.predictions);
          })
          .catch((error) => {
            console.log(error);
            setAddressSuggestions([]);
          });
      } else {
        setAddressSuggestions([]);
      }
    }, 500),
    []
  );

  const handleAddressItemClick = async (item) => {
    setAddressSuggestions("");
    // setFormData({
    //   ...formData,
    //   add_lin_1: item.formatted_address,
    // });
    // setAddressSearchTerm(item.formatted_address);
    // setAddressSuggestions("");
    await axios
      .get(API_BASE_URL + `googleapiplaceidsearch/?place_id=${item.place_id}`, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        let formattedData = JSON.parse(response.data.data);

        const addressComponents = formattedData?.address_components || [];
        const updatedFormData = {
          add_lin_1: formattedData?.formatted_address1,
          add_lin_2: "",
          city: "",
          state: "",
          zip_code: "",
          state_name: "",
        };
        // setFormData({
        //   ...formData,
        //   add_lin_1: item.formatted_address,
        // });
        addressComponents.forEach((component) => {
          switch (component.types[0]) {
            case "locality":
              updatedFormData.city = component?.long_name;
              break;
            case "sublocality_level_1":
              updatedFormData.add_lin_2 = component?.long_name;
              break;
            case "postal_code":
              updatedFormData.zip_code = component?.long_name;
              break;
            case "administrative_area_level_1":
              const matchingState = citydata.find(
                (item) => item.name === component?.long_name
              );
              if (matchingState) {
                updatedFormData.state = matchingState?.id;
                updatedFormData.state_name = component?.long_name;
              } else {
                updatedFormData.state_name = "";
              }
              break;
            default:
              break;
          }
        });

        setFormData({
          ...formData,
          ...updatedFormData,
        });
      })
      .catch((error) => {
        console.log(error);
        setAddressSuggestions([]);
      });
  };

  const inputRef = useRef(null);
  const suggestionsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setAddressSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputRef, suggestionsRef]);

  const handleEmailClick = (
    cust_fname,
    cust_lname,
    cust_email,
    cust_contact_no,
    cust_id
  ) => {
    setCustfName(cust_fname);
    setCustlName(cust_lname);
    setCustContactNo(cust_contact_no);
    setCustEmail(cust_email);
    setCustId(cust_id);
    setCustDetail([]);
    setFormData({
      ...formData,
      cust_email: cust_email,
      cust_fname: cust_fname,
      cust_lname: cust_lname,
      cust_contact_no: cust_contact_no,
      cust_id: cust_id,
    });
  };

  const handleSubmit = (e) => {
    console.log(custEmail);
    e.preventDefault();
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true); // Disable the button

    setFormData({
      ...formData,
      rest_id: localStorage.getItem("id"),
      order_status: 1,
      items: menuItem,
      cust_email: custEmail,
      cust_fname: custfName,
      cust_lname: custlName,
      cust_contact_no: custContactNo,
      cust_id: custId,
      event_date: selectedDate,
    });
    console.log("SetformData", formData);

    // if (!formData.state && formData.state <= "0") {
    //   f7.toast
    //     .create({
    //       text: "Please select state",
    //       position: "top",
    //       cssClass: "bg-color-red",
    //       closeTimeout: 3000,
    //     })
    //     .open();
    //   setIsSubmitting(false);
    //   return;
    // } else
    if (!formData.items || formData.items.length <= 0) {
      f7.toast
        .create({
          text: "Please select menu items",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      setIsSubmitting(false);
      return;
    } else {
      console.log(formData);
      if (selectedRadio == "2") {
      }

      const dataString = JSON.stringify(formData);
      localStorage.setItem("order_data", dataString);

      f7.views.main.router.navigate({
        name: "pay_invoice",
      });

      setIsSubmitting(false);
    }
  };

  const currentDate = new Date().toISOString().slice(0, 16);
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const fetchData = async (searchTerm) => {
    try {
      const response = await fetch(
        API_BASE_URL +
          `menu/?search=${searchTerm}&rest_id=${localStorage.getItem("id")}`,
        {
          method: "GET", // Replace with the desired HTTP method (e.g., POST, PUT, DELETE)
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
        }
      );
      const data = await response.json();
      setSuggestions(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleMenuChange = (event) => {
    setSuggestions([]);
    const value = event.target.value;
    if (value.length > 0) {
      axios
        .get(
          API_BASE_URL +
            `menu/?search=${value}&rest_id=${localStorage.getItem("id")}`,
          {
            // Replace with the desired HTTP method (e.g., POST, PUT, DELETE)
            headers: {
              Authorization: "Basic " + API_AUTH,
            },
          }
        )
        .then((response) => setSuggestions(response.data))
        .catch((error) => {
          console.log(error);
          setSuggestions([]);
        });
    } else {
      setSuggestions([]);
    }
    setSearchTerm(value);
    setMenuAmount(0);
    setNoOfPer(0);
    setMenuSize([]);
  };

  const handleItemClick = (item, id) => {
    setSuggestions("");
    setSearchTerm(item);
    setSuggestions("");
    setRestMenu(id);
    axios
      .get(API_BASE_URL + "menu/id/" + id, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        setMenuSize(response.data[0].menu_size);
      })
      .catch((error) => console.log(error));
  };
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 0);

  const minBidDate = new Date();
  minBidDate.setDate(minDate.getDate() + 0);

  // useEffect(()=>{
  //   const event_data = JSON.parse(localStorage.getItem('order_data')) || [];
  //     setFormData(event_data);
  //     console.log(event_data);
  // },[]);
  const handleEdit = (index) => {
    f7.popup.open(".edit-demo-popup");
    const updatedProduct = [...menuItem];
    const menu_item = updatedProduct[index];
    console.log(index);
    setSearchTerm(menu_item.menu_name);
    handleItemClick(menu_item.menu_name, menu_item.menu_id);
    menuSizeAmount(menu_item.menu_amount, menu_item.size, menu_item.menu_size);
    calculateSum(menu_item.tray_size_id);
    setTotalAmt(menu_item.total_amount);
    setSelectedMenuSizeId(menu_item.menu_size);
    setMenuNote(menu_item.note);
    setEditIndex(index);
  };
  const handleUpdateCart = (event) => {
    event.preventDefault();
    const menu_name = event.target.elements.menu_name.value;
    const menu_id = menu_item_id;
    const rest_id = localStorage.getItem("id");
    const tray_size_id = event.target.elements.try_size.value;
    const menu_size = event.target.elements.menu_size.value;
    const menu_size_text =
      event.target.elements.menu_size.options[
        event.target.elements.menu_size.selectedIndex
      ].text;
    const menu_amount = event.target.elements.menu_amount.value;
    const size = event.target.elements.noOfPer.value;
    const note = event.target.elements.menu_note.value;
    if (menu_size == "Select Menu Size") {
      f7.toast
        .create({
          text: "Please Select Menu Size ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }
    if (menu_amount <= 0) {
      f7.toast
        .create({
          text: "Please Add Amount ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }
    if (tray_size_id <= 0 || !tray_size_id) {
      f7.toast
        .create({
          text: "Please Add Tray Size  ...!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }

    if (totalAmt <= 0) {
      f7.toast
        .create({
          text: "Please Add Tray Size ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }
    const menu_data = {
      menu_name: menu_name,
      menu_id: menu_id,
      rest_id: rest_id,
      tray_size_id: tray_size_id,
      menu_amount: menu_amount,
      size: size,
      note: note,
      item_status: 2,
      total_amount: totalAmt,
      menu_size: menu_size,
      menu_size_name: menu_size_text,
    };
    // setMenuItem([ ...menuItem, menu_data]);
    const updatedProduct = [...menuItem];
    const menu_item = updatedProduct[editIndex];
    console.log(menu_item);
    menu_item.menu_name = menu_name;
    menu_item.menu_id = menu_id;
    menu_item.rest_id = rest_id;
    menu_item.tray_size_id = tray_size_id;
    menu_item.size = size;
    menu_item.note = note;
    menu_item.item_status = 2;
    menu_item.total_amount = totalAmt;
    menu_item.menu_size = selectedMenuSizeId;
    menu_item.menu_size_text = menu_size_text;
    menu_item.menu_size_name = menu_size_text;
    menu_item.menu_amount = menu_amount;
    console.log(menu_item);

    setFormData({
      ...formData,
      rest_id: localStorage.getItem("id"),
      order_status: 1,
      items: menuItem,
      // grand_total : menuItem.reduce((acc, item) => acc + item.total_amount, 0),
      sub_total: menuItem.reduce((acc, item) => acc + item.total_amount, 0),
      cust_email: custEmail,
      cust_fname: custfName,
      cust_lname: custlName,
      cust_contact_no: custContactNo,
      cust_id: custId,
      event_date: selectedDate,
      order_id: id,
    });

    f7.popup.close(".edit-demo-popup");
    setSearchTerm("");
    setTotalAmt(0);
    setMenuAmount(0);
    setNoOfPer(0);
    setTraySize(0);
    formRef.current.reset();
  };

  const addNewMenu = () => {
    f7.popup.close(".demo-popup");
    f7.views.main.router.navigate("/addmenupopup/");
  };

  return (
    <Page className="bg-white">
      {/* <Navbar title="Restaurant Information" backLink="Back" noShadow/> */}
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="custom-container container-lg p-0">
              <div className="header-panel">
                <Link href="#" back>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Update Order </h2>
              </div>
            </div>
          </header>
          <section>
            {isSubscription ? (
              <div className="custom-container p-0">
                <div class="title">
                  <h3 class="mt-0">Order Details</h3>
                </div>
                <form
                  className="auth-form address-form mt-3"
                  onSubmit={handleSubmit}
                >
                  <div className="form-group">
                    <label className="form-label fw-semibold">
                      Name of the Event
                    </label>
                    <div className="form-input mb-4">
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        required
                        validate
                        pattern=".{3,}"
                        errorMessage="Please enter name of the event."
                        placeholder="Name of the Event"
                        name="event_name"
                        value={formData.event_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label fw-semibold">
                      Date and time of the Event
                    </label>
                    <div className="form-input mb-4">
                      {/* <Input type="datetime-local" className="form-control" min={FUTURE_DATE} required validate errorMessage="Please select date of event." placeholder="Event Date and time" name="event_date" value={formData.event_date} onChange={handleChange}/> */}
                      <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        showTimeSelect
                        timeFormat="h:mm aa"
                        timeIntervals={15}
                        dateFormat="MM-dd-yyyy h:mm aa"
                        placeholderText="Select event date and time"
                        className="form-control col-md-12"
                        minDate={minDate}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="form-group" style={{ width: "49%" }}>
                      <label className="form-label fw-semibold">
                        No of Adults
                      </label>
                      <div className="form-input mb-4">
                        <Input
                          type="text"
                          required
                          validate
                          pattern="[0-9\s]{1,4}"
                          errorMessage="Please enter no of adults."
                          className="form-control"
                          placeholder="No of Adults"
                          name="event_adult_size"
                          value={formData.event_adult_size}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group" style={{ width: "49%" }}>
                      <label className="form-label fw-semibold">
                        No of Kids
                      </label>
                      <div className="form-input mb-4">
                        <Input
                          type="text"
                          validate
                          pattern="[0-9\s]{1,4}"
                          errorMessage="Please enter no of kids."
                          className="form-control"
                          placeholder="No of Kids"
                          name="event_kids_size"
                          value={formData.event_kids_size}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <List style={{ marginTop: "10px" }}>
                      {/* <label className="form-label fw-semibold">
                          Deliver type
                        </label> */}
                      <ListItem
                        radio
                        value="1"
                        name="Delivery"
                        title="Delivery"
                        checked={selectedRadio === "1"}
                        onChange={() => handleRadioChange("1")}
                      ></ListItem>
                      <ListItem
                        radio
                        value="2"
                        name="Pickup"
                        title="Pickup"
                        checked={selectedRadio === "2"}
                        // defaultChecked
                        onChange={() => handleRadioChange("2")}
                      ></ListItem>
                    </List>
                  </div>

                  {selectedRadio !== "2" && (
                    <>
                      <h4 className="mb-3 text-3 fw-bold">Event Address</h4>
                      <div className="form-group">
                        <label className="form-label fw-semibold">
                          Address 1
                        </label>

                        <div className="form-input mb-2">
                          <input
                            ref={inputRef}
                            // required
                            // validate
                            // pattern=".{5,}"
                            errorMessage="Please enter event address."
                            className="form-control"
                            placeholder="Event Address"
                            name="add_lin_1"
                            value={formData.add_lin_1}
                            // value={addressSearchTerm}
                            autoComplete="off"
                            onChange={handleAddressChange}
                          />
                        </div>
                        <div
                          className="form-input mb-4"
                          style={{ width: "100%" }}
                        >
                          {addressSuggestions.length > 0 &&
                          formData.add_lin_1 !== "" ? (
                            <ul
                              ref={suggestionsRef}
                              className="auto-complete-list"
                              style={{
                                width: "93%",
                                zIndex: 99,
                                minHeight: "auto",
                                maxHeight: "250px",
                                backgroundColor: "white",
                                overflow: "scroll",
                                overflowX: "hidden",
                              }}
                            >
                              {addressSuggestions.map((item) => (
                                <li
                                  key={item.id}
                                  onClick={() => {
                                    handleAddressItemClick(item);
                                    // setFormData({
                                    //   ...formData,
                                    //   add_lin_1: item.formatted_address,
                                    // });
                                  }}
                                  style={{ border: "1px solid #E5E7EB" }}
                                >
                                  {item.description}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label fw-semibold">
                          Address 2
                        </label>
                        <div className="form-input mb-4">
                          <Input
                            type="text"
                            errorMessage="Please enter event second address."
                            className="form-control"
                            placeholder="Event Address"
                            name="add_lin_2"
                            value={formData.add_lin_2}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label fw-semibold">City</label>
                        <div className="form-input mb-4">
                          <Input
                            type="text"
                            // required
                            // validate
                            // pattern="[a-zA-Z ]{2,}"
                            errorMessage="Please enter city."
                            className="form-control"
                            placeholder="City"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label fw-semibold">State</label>
                        <div className="form-input mb-4">
                          <select
                            className="form-select form-control"
                            // required
                            // validate
                            errorMessage="Please select State"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                          >
                            <option value="0">Select State</option>
                            {citydata.map((item) => (
                              <option value={item.id}>{item.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label fw-semibold">
                          Zip Code
                        </label>
                        <div className="form-input mb-4">
                          <Input
                            type="tel"
                            className="form-control"
                            // required
                            // validate
                            // pattern="[0-9]{5}"
                            placeholder="Enter Zip Code"
                            errorMessage="Please enter zip code."
                            name="zip_code"
                            value={formData.zip_code}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label fw-semibold">
                          Additional Instructions
                        </label>
                        <div className="form-input mb-4">
                          <Input
                            type="text"
                            // validate
                            // pattern=".{5,}"
                            errorMessage="Please enter event note."
                            className="form-control"
                            placeholder="Enter Additional Instructions"
                            name="event_note"
                            value={formData.event_note}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <h4 className="mb-3 text-3 fw-bold">Customer Details</h4>
                  <div className="form-group">
                    <label className="form-label fw-semibold">First Name</label>
                    <div className="form-input mb-4">
                      <Input
                        type="text"
                        required
                        validate
                        pattern="[A-Za-z0-9 ]{3,25}"
                        errorMessage="First Name."
                        className="form-control"
                        placeholder="Customer first name"
                        name="cust_fname"
                        value={custfName}
                        onChange={(e) => setCustfName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label fw-semibold">Last Name</label>
                    <div className="form-input mb-4">
                      <Input
                        type="text"
                        validate
                        pattern="[A-Za-z0-9 ]{3,25}"
                        errorMessage="Last Name."
                        className="form-control"
                        placeholder="Customer last name"
                        name="cust_lname"
                        value={custlName}
                        onChange={(e) => setCustlName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label fw-semibold">
                      Email Address
                    </label>
                    <div className="form-input mb-4">
                      <Input
                        type="email"
                        required
                        validate
                        placeholder="Email"
                        errorMessage="Please enter email address."
                        className="form-control"
                        name="cust_email"
                        value={custEmail}
                        onChange={(e) => setCustEmail(e.target.value)}
                      />
                      <ul className="auto-complete-list">
                        {custDetail && custDetail.length > 0
                          ? custDetail.map((item) => (
                              <li
                                className="bg-white"
                                key={item.id}
                                onClick={() =>
                                  handleEmailClick(
                                    item.cust_fname,
                                    item.cust_lname,
                                    item.cust_email,
                                    item.cust_contact_no,
                                    item.id
                                  )
                                }
                              >
                                {item.cust_email}
                              </li>
                            ))
                          : ""}
                      </ul>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label fw-semibold">Phone</label>
                    <div className="form-input mb-4">
                      <Input
                        type="tel"
                        required
                        validate
                        placeholder="Phone"
                        errorMessage="Please enter phone."
                        className="form-control"
                        name="cust_contact_no"
                        value={custContactNo}
                        onChange={(e) => setCustContactNo(e.target.value)}
                      />
                    </div>
                  </div>
                  <div class="title">
                    <h3 class="mt-0">Menu Details</h3>
                    <a href="#">
                      <Button
                        fill
                        small
                        className="text-white btn-success filter-button mt-1 text-1"
                        popupOpen=".demo-popup"
                      >
                        {" "}
                        Add Menu{" "}
                      </Button>
                    </a>
                  </div>
                  <div className="auth-form address-form mt-0 mb-0"></div>
                  <table className="table table-striped table-sm text-2 mt-0">
                    <tbody className="mt-2 ">
                      {menuItem.map((items, index) => (
                        <tr className="align-middle" key={index}>
                          <td width={"10%"} className="text-center">
                            {index + 1}.
                          </td>
                          <td colSpan={3}>
                            <h5 className="dark-text fw-bold mb-1 text-capitalize">
                              {" "}
                              {items.menu_name}
                            </h5>
                            Type : {items.menu_size_name} ({items.size}) <br />
                            Tray Count: {items.tray_size_id}, Price :{" "}
                            <b> ${items?.total_amount?.toFixed(2)}</b>
                            <br />
                            Note : {items.note}
                          </td>
                          {/* <td width={'20%'} className='text-center'><a href="#" className="btn btn-xs theme-btn order mt-2 p-1 text-3" role="button" onClick={() => handleDelete(index)}>Delete</a></td> */}
                          {/* <td width={'15%'} className='text-center text-md-end'><a href="#" className="btn btn-xs btn-danger order mt-1 p-1 text-3 w-100" role="button" onClick={() => handleDelete(index)}>  Delete  </a></td> */}
                          {/* <td width={'15%'} className='text-center text-md-end'><a href="#" popupOpen=".demo-popup" className="btn btn-xs btn-success order mt-1 p-1 text-3 w-100" role="button" onClick={() => handleEdit(index)}>  Edit  </a></td> */}

                          <td width={"10%"} className="text-center">
                            <a
                              href="#"
                              role="button"
                              onClick={() => handleEdit(index)}
                            >
                              <Icon
                                material="edit"
                                className="text-success"
                              ></Icon>
                            </a>
                          </td>
                          <td width={"10%"} className="text-center">
                            <a
                              href="#"
                              role="button"
                              onClick={() => handleDelete(index)}
                            >
                              {" "}
                              <Icon
                                material="delete"
                                className="text-danger"
                              ></Icon>{" "}
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    {/* <tr className='table-success border p-2'><th colSpan={2} className='mt-0'><h4 className='text-end mt-2 fw-bold color-green'>Total Number of menu: </h4></th><th><h4 className='text-end mt-2 fw-bold color-green'>{data.length}</h4></th></tr> */}
                  </table>
                  <Button
                    type="submit"
                    className="btn theme-btn w-100"
                    large
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Updating..." : "Update Order"}
                  </Button>
                  {/* <Button className="btn theme-btn w-100" large type="submit">Add Order</Button>             */}
                </form>
              </div>
            ) : (
              <Block>
                <div className="custom-container">
                  <div className="empty-tab">
                    <h2>Need to subscribe !!</h2>
                    <h5 className="mt-3 lh-base">
                      Kindly get in touch with the Eatbids administrative team.
                    </h5>
                  </div>
                </div>
              </Block>
            )}
          </section>

          <section className="section-b-space pt-2">
            <div className="custom-container"></div>
          </section>
          <Popup className="demo-popup custom-web">
            <Page>
              <div className="search-filter modal-dialog modal-fullscreen custom-web">
                <div className="modal-content">
                  {/* <div className="modal-title">
                    <h3 className="fw-bold">Add Item Details</h3>
                    <Link className="btn-close" popupClose/>
                  </div> */}
                  <header className="section-t-space">
                    <div className="container-lg custom-container p-0">
                      <div className="header-panel">
                        <Link />
                        <h2>Add Item Details</h2>
                        <Link
                          className="btn-close"
                          popupClose
                          style={{ marginRight: "15px" }}
                        />
                      </div>
                    </div>
                  </header>
                  <section className="section-b-space">
                    <div className="custom-container">
                      <form
                        id="formAddCart"
                        ref={formRef}
                        onSubmit={handleAddToCart}
                        className="auth-form profile-form"
                      >
                        <div className="form-group">
                          <div class="title">
                            <h3 class="mt-0">Menu Details</h3>
                            <a href="#">
                              <Button
                                fill
                                small
                                className="text-white btn-success filter-button mt-1 text-1"
                                onClick={addNewMenu}
                              >
                                {" "}
                                Add New Menu{" "}
                              </Button>
                            </a>
                          </div>
                          <label className="form-label fw-semibold">Menu</label>
                          <div className="form-input mb-4">
                            <input
                              type="text"
                              id="inputMenu"
                              className="form-control"
                              required
                              validate
                              value={searchTerm}
                              name="menu_name"
                              autoComplete="off"
                              // value={product.menu_name}
                              onChange={handleMenuChange}
                              placeholder="Type to search..."
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          {suggestions.length > 0 && (
                            <ul className="auto-complete-list ">
                              {suggestions.map((item) => (
                                <li
                                  key={item.id}
                                  onClick={() =>
                                    handleItemClick(
                                      item.menu_item_name,
                                      item.menu_item_id
                                    )
                                  }
                                >
                                  {item.menu_item_name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Menu Size
                          </label>
                          <div className="form-input mb-4">
                            <select
                              name="menu_size"
                              id="menu_size"
                              className="form-select form-control"
                              onChange={(event) =>
                                menuSizeAmount(
                                  event.target.options[
                                    event.target.selectedIndex
                                  ].getAttribute("amount"),
                                  event.target.options[
                                    event.target.selectedIndex
                                  ].getAttribute("data-size"),
                                  event.target.options[
                                    event.target.selectedIndex
                                  ].value
                                )
                              }
                            >
                              <option amount={0} size={0}>
                                {" "}
                                Select Menu Size
                              </option>
                              {menuSize.length > 0 && (
                                <>
                                  {menuSize.map((item) => (
                                    <option
                                      key={item.id}
                                      amount={item.menu_amount}
                                      data-size={item.size}
                                      value={item.menu_size_id}
                                    >
                                      {item.menu_size_name}
                                    </option>
                                  ))}
                                </>
                              )}
                            </select>
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Serves
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="noOfPer"
                              className="form-control"
                              required
                              validate
                              value={noOfPer}
                              name="noOfPer"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Amount
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="inputMenu"
                              className="form-control"
                              // required
                              // validate
                              onChange={(e) => setMenuAmount(e.target.value)}
                              value={menuAmount}
                              name="menu_amount"
                              min="0"
                              pattern="[0-9]+([.][0-9]{0,2})?"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Tray Count/No of Pieces
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="number"
                              id="try_size"
                              className="form-control"
                              name="try_size"
                              onChange={(e) => calculateSum(e.target.value)}
                              min="0"
                              value={traySize}
                              // required validate pattern="[0-9]+(\.[0-9]{1,2})?" errorMessage='Please enter valid count'
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Total Amount
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="number"
                              id="total_amount"
                              className="form-control"
                              name="total_amount"
                              value={totalAmt}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Menu Note
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="menu_note"
                              className="form-control"
                              name="menu_note"
                            />
                          </div>
                        </div>
                        <Button
                          type="submit"
                          fill
                          large
                          className="btn theme-btn save-address w-100"
                        >
                          Add Item
                        </Button>
                      </form>
                    </div>
                  </section>
                </div>
              </div>
            </Page>
          </Popup>
          <Popup className="edit-demo-popup custom-web">
            <Page>
              <div className="search-filter modal-dialog modal-fullscreen custom-web">
                <div className="modal-content">
                  {/* <div className="modal-title">
                    <h3 className="fw-bold">Add Item Details</h3>
                    <Link className="btn-close" popupClose/>
                  </div> */}
                  <header className="section-t-space">
                    <div className="container-lg custom-container p-0">
                      <div className="header-panel">
                        <Link />
                        <h2>Add Item Details</h2>
                        <Link
                          className="btn-close"
                          popupClose
                          style={{ marginRight: "15px" }}
                        />
                      </div>
                    </div>
                  </header>
                  <section className="section-b-space">
                    <div className="custom-container">
                      <form
                        id="formAddCart"
                        ref={formRef}
                        onSubmit={handleUpdateCart}
                        className="auth-form profile-form"
                      >
                        <div className="form-group">
                          <label className="form-label fw-semibold">Menu</label>
                          <div className="form-input mb-4">
                            <input
                              type="text"
                              id="inputMenu"
                              className="form-control"
                              required
                              validate
                              value={searchTerm}
                              name="menu_name"
                              autoComplete="off"
                              // value={product.menu_name}
                              onChange={handleMenuChange}
                              placeholder="Type to search..."
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          {suggestions.length > 0 && (
                            <ul className="auto-complete-list ">
                              {suggestions.map((item) => (
                                <li
                                  key={item.id}
                                  onClick={() =>
                                    handleItemClick(
                                      item.menu_item_name,
                                      item.menu_item_id
                                    )
                                  }
                                >
                                  {item.menu_item_name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Menu Size
                          </label>
                          <div className="form-input mb-4">
                            <select
                              name="menu_size"
                              id="menu_size"
                              value={selectedMenuSizeId}
                              className="form-select form-control"
                              onChange={(event) =>
                                menuSizeAmount(
                                  event.target.options[
                                    event.target.selectedIndex
                                  ].getAttribute("amount"),
                                  event.target.options[
                                    event.target.selectedIndex
                                  ].getAttribute("data-size"),
                                  event.target.options[
                                    event.target.selectedIndex
                                  ].value
                                )
                              }
                            >
                              <option amount={0} size={0}>
                                {" "}
                                Select Menu Size
                              </option>
                              {menuSize.length > 0 && (
                                <>
                                  {menuSize.map((item) => (
                                    <option
                                      key={item.id}
                                      amount={item.menu_amount}
                                      data-size={item.size}
                                      value={item.menu_size_id}
                                    >
                                      {item.menu_size_name}
                                    </option>
                                  ))}
                                </>
                              )}
                            </select>
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Serves
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="noOfPer"
                              className="form-control"
                              required
                              validate
                              value={noOfPer}
                              name="noOfPer"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Amount
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="inputMenu"
                              className="form-control"
                              // required
                              // validate
                              onChange={(e) => setMenuAmount(e.target.value)}
                              value={menuAmount}
                              name="menu_amount"
                              min="0"
                              pattern="[0-9]+([.][0-9]{0,2})?"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Tray Count/No of Pieces
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="number"
                              id="try_size"
                              className="form-control"
                              name="try_size"
                              onChange={(e) => calculateSum(e.target.value)}
                              min="0"
                              value={traySize}
                              // required validate pattern="[0-9]+(\.[0-9]{1,2})?" errorMessage='Please enter valid count'
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Total Amount
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="number"
                              id="total_amount"
                              className="form-control"
                              name="total_amount"
                              value={totalAmt}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Menu Note
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="menu_note"
                              className="form-control"
                              name="menu_note"
                              value={menuNote}
                              onChange={(e) => setMenuNote(e.target.value)}
                            />
                          </div>
                        </div>
                        <Button
                          type="submit"
                          fill
                          large
                          className="btn theme-btn save-address w-100"
                        >
                          Add Item
                        </Button>
                      </form>
                    </div>
                  </section>
                </div>
              </div>
            </Page>
          </Popup>
        </div>
      </div>
    </Page>
  );
};

export default EditOrder;
